import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

import RedirectButton from 'components/Common/Buttons/RedirectButton';
import ErrorGraphic from '../ErrorGraphic';

const UnlicensedPage = ({ caption }) => (
  <div>
    <ErrorGraphic />
    <div className="message-404-box">
      <h1>Access Not Granted</h1>
      <p>{ caption }</p>
      <div className="buttons-con">
        <div className="action-link-wrap">
          <RedirectButton
            to="/"
            title="Go back"
            className="btn link-go-back"
            redirectBack
          />
          <Link to="/" className="link-button">Go to home page</Link>
        </div>
      </div>
    </div>
  </div>
);

UnlicensedPage.propTypes = {
  caption: PropTypes.string
};

UnlicensedPage.defaultProps = {
  caption: 'You have not been permissioned to access this module. Please contact your vendor manager.'
};

export default UnlicensedPage;
